import React, { useState, useEffect } from 'react';
import classNames from '../helpers/classNames.js';
const getOptions = options => typeof options === 'string' ? options.split(',') : options;
const OptionBar = ({
  options,
  defaultOption = '',
  onChange
}) => {
  const [items, setItems] = useState(getOptions(options));
  const [selected, setSelected] = useState(defaultOption || '');
  useEffect(() => {
    setItems(getOptions(options));
    setSelected(defaultOption);
  }, [options, defaultOption]);
  const handleOnClick = option => {
    if (option === selected) {
      return;
    }
    if (onChange) {
      onChange(option);
    }
    setSelected(option);
  };
  const getClassNames = isActive => classNames('ebds-option-bar__button', {
    '--active': isActive
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-option-bar"
  }, items.map(option => option.trim()).map(option => /*#__PURE__*/React.createElement("button", {
    key: option,
    type: "button",
    className: getClassNames(option === selected),
    onClick: () => handleOnClick(option)
  }, option)));
};
export default OptionBar;